import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import { ExpandableContent, StandardPolicies } from 'ui-shared-components';
import type {
  SearchProducts,
  Policy,
  StandardPolicy,
} from '@white-label-types/parking-booking';


export default /*#__PURE__*/_defineComponent({
  __name: 'policies-more-info-modal',
  props: {
    product: null,
    isBookingFeeCharged: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as { product: SearchProducts, isBookingFeeCharged: boolean };



const transformProductData = computed(() => {
  const productName = props.product.name;
  const transformedPolicies = (policies: Policy[]) =>
    policies?.map((policy) => ({
      title: `${productName}`,
      message: policy.message,
    }));
  const productOption = props.product?.productOptions?.[0] || {
    cancellation_policies: [],
    amendment_policies: [],
  };
  return {
    cancellation_policies: transformedPolicies(
      productOption.cancellation_policies
    ),
    amendment_policies: transformedPolicies(productOption.amendment_policies),
  };
});

const policies = computed((): StandardPolicy[] => {
  return transformProductData.value?.cancellation_policies?.map(
    (policy, index) => ({
      product_name: props.product.name,
      cancellation_policy: policy.message,
      amendment_policy:
        transformProductData.value.amendment_policies[index]?.message || '',
    })
  );
});

return { __sfc: true,props, transformProductData, policies, ExpandableContent, StandardPolicies }
}

})